import React from 'react';
import './Fighter.css';

class Fighter extends React.Component {
  render() {
    let color;
    if (this.counterRating > 5.5) {
      color = "green";
    } else if (this.counterRating < 4.5) {
      color = "red";
    }

    let styles = {
      backgroundImage: "url("+this.props.image+")",
      opacity: this.props.playMetric / this.props.maxMetric,
      borderColor: color
    }

    return (
      <div className="fighter box" style={this.props.counterRow ? {backgroundImage: "url("+this.props.image+")",
      opacity: 1,
      borderColor: color} : styles}>
        <div className="metric">{this.props.counterRow ? this.props.counterRating : <p></p>}</div>
      </div>
    );
  }
}

export default Fighter;



// WEBPACK FOOTER //
// ./src/Components/Fighter/Fighter.js